// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLastMonthDataButton_root__LBWrq","text":"PlasmicLastMonthDataButton_text__I3Nbv"};